/* eslint-disable arrow-body-style */
import { API, Auth, Logger } from 'aws-amplify';

const logger = new Logger('VIRSApiService.js');
const VIRS_API_NAME = 'VirsApiProxy';

/**
 * Request Options to include authorization headers on all requests
 */
const requestOptions = () => {
  logger.debug('requestOptions..');
  return Auth.currentAuthenticatedUser()
    .then((user) => {
      return {
        headers: {
          'Content-Type': 'application/json',
          'x-api-authorization': `Bearer ${user.signInUserSession.accessToken.jwtToken}`,
        },
      };
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
};

/**
 * Request Wrapper to call the request options on all requests
 * @param {*} request
 */
const requestWrapper = (request) => {
  return requestOptions().then((options) => request(options));
};

const getItemsByVendorCode = (vendorId) => {
  return requestWrapper((options) => {
    // make api request
    return API.get(VIRS_API_NAME, `/vendors/${encodeURI(vendorId)}/vendorItems`, options);
  });
};

export {
  requestWrapper,
  getItemsByVendorCode
};
